import { Link } from 'react-router-dom';
import styled from 'styled-components';
import theme from '@styles/theme';

export const Container = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: ${theme.colors.whiteColor};
    z-index: 100;
`;

export const Header = styled.header`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100px;
`;

export const Logo = styled.h1`
    margin-bottom: 8px;
    font-size: 32px;
    font-family: MusinsaMedium, sans-serif;
`;

export const SubTitle = styled.div`
    font-size: 18px;
    color: ${theme.colors.grayFont};
`;

export const Contents = styled.section`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px;
    height: calc(100vh - 100px);
    font-family: 'AppleSDGothicNeoMedium', sans-serif;
`;

export const Image = styled.img`
    display: block;
    margin-bottom: 50px;
    width: 124px;
`;

export const Title = styled.h2`
    margin-bottom: 30px;
    font-size: 30px;
    text-align: center;
    line-height: 1.2;
`;

export const Text = styled.div`
    margin-bottom: 60px;
    color: ${theme.colors.grayFont};
    text-align: center;
    line-height: 1.4;
`;

export const HomeButton = styled(Link)`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 134px;
    height: 46px;
    font-size: 16px;
    font-family: 'AppleSDGothicNeoBold', sans-serif;
    color: ${theme.colors.whiteColor};
    margin-bottom: 12px;
    border-radius: 8px;
    background-color: ${theme.colors.blackColor};
`;

export const PrevPageButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 134px;
    height: 46px;
    font-size: 16px;
    font-family: 'AppleSDGothicNeoBold', sans-serif;
    color: ${theme.colors.grayFont};
    border-radius: 8px;
    background-color: ${theme.colors.whiteColor};
`;
